import { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import moment from 'moment';

import FlowProgress from 'components/organisms/flowProgress/index.jsx';
import FlowProgressStep from 'components/molecules/flowProgressStep/index.jsx';

class WizardProgress extends Component {
  render() {
    const activeStep = parseInt(this.props.step);

    const getStatus = step => {
      if (activeStep === step) {
        return 'active';
      } else if (activeStep > step) {
        return 'complete';
      }

      return 'inactive';
    };

    const {
      vehicle,
      engine,
      transmission,
      traction,
      services,
      wants_dynamic_reception,
      personalInfo,
      license_plate,
      date,
      hour,
      advisor,
    } = this.props;

    return (
      <FlowProgress>
        <FlowProgressStep
          number="1"
          name="Datos del vehículo"
          requestedData={
            (vehicle ? vehicle.name : '') +
            ' ' +
            (transmission ? transmission.name : '') +
            ' ' +
            (traction ? traction.name : '')
          }
          status={getStatus(1)}
        />
        <FlowProgressStep
          number="2"
          name="Servicios"
          requestedData={
            services &&
            services.map(service => (service ? service.name + ' ' : '')) +
              (wants_dynamic_reception ? ' Recepción dinámica' : '')
          }
          status={getStatus(2)}
        />
        <FlowProgressStep
          number="3"
          name="Fecha del turno"
          requestedData={moment(date).format('dddd D \\d\\e MMMM')}
          status={getStatus(3)}
        />
        <FlowProgressStep
          number="4"
          name="Hora del turno"
          requestedData={hour}
          status={getStatus(4)}
        />
        <FlowProgressStep
          number="5"
          name="Asesores"
          requestedData={advisor ? advisor.name + ' ' + advisor.lastname : ''}
          status={getStatus(5)}
        />
        <FlowProgressStep
          number="6"
          name="Datos Personales"
          requestedData={
            personalInfo
              ? personalInfo.name +
                ' ' +
                personalInfo.lastname +
                ', ' +
                personalInfo.dni +
                ' ' +
                license_plate
              : ''
          }
          status={getStatus(6)}
        />
        <FlowProgressStep
          number="7"
          name="Confirmar Turno"
          requestedData="Tipo de servicio."
          status={getStatus(7)}
        />
      </FlowProgress>
    );
  }
}

const selector = formValueSelector('shiftRequest');

WizardProgress = connect(state => {
  return {
    vehicle: selector(state, 'vehicle'),
    engine: selector(state, 'engine'),
    transmission: selector(state, 'transmission'),
    traction: selector(state, 'traction'),
    services: selector(state, 'services'),
    date: selector(state, 'date'),
    hour: selector(state, 'hour'),
    advisor: selector(state, 'advisor'),
  };
})(WizardProgress);

export default WizardProgress;
